/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CogRegularReport from './cog-regular-report-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CogRegularReport {...validProps} />;
}

SvgComponent.iconName = 'cogRegularReport';

export const CogRegularReportIcon = svgIconWrapper(SvgComponent);
